function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.18,
  d: "M499.513 447.432V0.555664C499.513 0.555664 436.651 28.8628 397.95 28.0377C372.38 27.5151 383.168 33.5823 359.865 44.0616C335.373 55.0636 314.919 79.2077 290.04 88.6419C273.454 94.8579 222.477 87.0267 206.251 94.013C185.822 102.842 118.16 150.052 107.959 169.746C97.7591 189.439 3.95334 222.703 0.000366211 244.404V437.432C0.000366211 442.955 4.47752 447.432 10.0004 447.432H499.513Z",
  fill: "#00B0F0"
});

var SvgSignupMtn = function SvgSignupMtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 448,
    viewBox: "0 0 500 448",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignupMtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Signup_mtn.f3d97f3c.svg";
export { ForwardRef as ReactComponent };